// ── 마케터 지정 창 — 다른 회사에 이미 등록된 3.3% 인원을 이 회사 담당으로 추가 (2026-09-08 P3) ──────
// 2026-11-03 직원 관리 한 목록으로 합치며 예전 MarketerTabView 에서 창 부분만 옮겼다. 2026-11-04 여는 곳 = 직원 관리 ☰ 메뉴(버튼에서 옮김).
//   계정을 새로 만들지 않고 담당 연결만 더한다 — 여러 회사를 도는 사람도 계정·실적이 하나.
import React, { useMemo, useState } from 'react';
import Modal from '../../../components/Modal';
import { tableActionBtn, searchInputStyle } from './styles';
import { isNoId } from './utils';
import { KIND_LABEL, rowKind, kindBadgeStyle } from './userRowKind';

export default function MarketerAssignModal({ open, onClose, companyCode, candidates, linkedIds, linkMarketer }) {
  const [query, setQuery] = useState('');
  // 후보 = 이미 등록된 3.3% 중 이 회사에 아직 연결 안 된 사람. 동명이인 대비로 아이디·계정번호를 함께 보여주고 선택도 id 로.
  const filteredCandidates = useMemo(() => {
    const q = query.trim().toLowerCase();
    return (candidates || [])
      .filter((c) => !linkedIds.has(String(c.id)))
      .filter((c) => !q || String(c.name || '').toLowerCase().includes(q) || String(c.user_id || '').toLowerCase().includes(q));
  }, [candidates, linkedIds, query]);

  if (!open) return null;
  return (
    <Modal open onClose={() => { setQuery(''); onClose(); }} title={`${companyCode} 담당 마케터 지정`} width="min(520px, calc(100vw - 48px))">
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 10, lineHeight: 1.6 }}>
        이미 등록된 3.3% 인원 중에서 고릅니다. 계정을 새로 만들지 않고 <b>이 회사 담당으로만 추가</b>되므로,
        여러 회사를 도는 사람도 계정·실적이 하나로 유지됩니다.
        아직 등록된 적 없는 사람은 오른쪽 위 <b>+ 직원 등록</b>에서 구분을 <b>3.3%</b>로 골라 만드세요(등록과 동시에 이 회사 담당이 됩니다).
      </div>
      <input
        style={{ ...searchInputStyle, width: '100%', marginBottom: 10 }}
        placeholder="이름 또는 아이디로 검색"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoFocus
      />
      <div style={{ maxHeight: 320, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 8 }}>
        {filteredCandidates.length === 0 && (
          <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13, lineHeight: 1.6 }}>
            {query.trim()
              ? `'${query.trim()}' 와 일치하는 사람이 없습니다.`
              : (candidates || []).length === 0
                ? '이 회사에 지정할 수 있는 3.3% 인원이 없습니다. 오른쪽 위 [+ 직원 등록]에서 3.3%로 먼저 만들어 주세요.'
                : '등록된 3.3% 인원이 모두 이미 이 회사 담당입니다.'}
          </div>
        )}
        {filteredCandidates.map((c) => (
          <div key={c.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '9px 12px', borderBottom: '1px solid var(--border)' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>
                {c.name}
                <span style={{ ...kindBadgeStyle(rowKind(c)), marginLeft: 6 }}>{KIND_LABEL[rowKind(c)]}</span>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                {isNoId(c.user_id) ? '아이디 없음' : c.user_id} · 계정 #{c.id}
                {(c.linked_companies || []).length > 0 && ` · 현재 ${c.linked_companies.join(', ')} 담당`}
              </div>
            </div>
            <button style={tableActionBtn} onClick={async () => { if (await linkMarketer(c.id)) { setQuery(''); onClose(); } }}>
              지정
            </button>
          </div>
        ))}
      </div>
    </Modal>
  );
}
